"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 120 120", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { fill: fill, cx: "60", cy: "60", r: "60" }),
        react_1.default.createElement("g", { fill: "#ffffff" },
            react_1.default.createElement("path", { d: "M 46.835 20.835 L 46.835 24.395 C 41.275 24.935 40.645 26.445 40.645 28.925 C 40.645 30.435 41.115 32.165 41.505 33.565 L 53.575 80.075 L 63.835 39.495 C 64.385 37.125 65.165 34.635 65.165 32.155 C 65.165 26.655 62.115 24.715 58.665 24.385 L 58.665 20.825 L 77.935 20.825 L 77.935 24.385 C 73.075 25.895 70.805 26.755 67.355 41.435 L 52.465 101.115 L 45.885 101.115 L 29.985 40.145 C 28.185 33.345 26.855 25.255 20.735 24.395 L 20.735 20.835 Z" }),
            react_1.default.createElement("path", { d: "M 77.785 99.825 L 77.785 96.475 C 80.605 96.475 82.955 96.045 82.955 87.625 L 82.955 65.725 C 82.955 60.005 81.935 56.115 77.395 55.365 L 77.395 52.025 L 94.245 45.445 L 94.245 89.475 C 94.325 95.845 96.905 96.495 99.265 96.495 L 99.265 99.845 L 77.785 99.845 Z M 88.045 18.885 C 91.725 18.885 94.625 22.985 94.625 27.955 C 94.625 33.025 91.725 37.025 88.045 37.025 C 84.445 37.025 81.465 33.035 81.465 27.955 C 81.465 22.995 84.445 18.885 88.045 18.885" }))));
};
var Vikebladet = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#c1342e' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill }, rest));
};
exports.default = Vikebladet;
